/***
 * Created on 2024/3/28
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/
import React, {useState} from 'react';
import {useTranslation} from "react-i18next";
import {useOnChange} from "common/Hook";
import {getErrorMessage} from 'common/ServiceCommon';
import QnapAuthAppTimer from "./qnap_auth_app_timer";
import {useMutation} from "@tanstack/react-query";
import {apiPost} from "../../service/api";
import NotReceiveCodeDialog from "./not_recieve_code_dialog";


function QnapAuthByVerifyVerificationComponent({isObserver, onLaunchQnapAuth, signout, otherWay, twoStepInfo}) {
    const {t} = useTranslation();
    const cur_url = new URL(location.href);
    const [errorMessage, setErrorMessage] = useState();
    const [showNotReceiveCode, setShowNotReceiveCode] = useState(false);
    const {values, setValues, onChange} = useOnChange({
        code: ''
    });

    const getTimerLeft = () => {
        let timer = twoStepInfo?.data?.current_qnap_auth_method?.expires;
        if (!timer) {
            return undefined;
        }
        timer = timer ? parseInt(timer) : 0;
        const current = new Date().getTime();
        const left = Math.round(timer - current) / 1000;
        // return left <= 0 ? 0 : left;
        return left;
    }

    const onCountDownToZero = () => {
         location.href = `/signout${location.search}`;
    }

    const verifyMutation = useMutation({
        mutationFn: async (data) => await apiPost('/ajax/qnap_auth/passcode', data),
        onSuccess: data => {
            const url = new URL(location.href);
            const state = url.searchParams.get('state');
            const lang = url.searchParams.get('lang');
            if (state && state !== '') {
                location.href = `/login?${url.searchParams.toString()}`
            }
            else {
                location.href = '/login?state=/account';
            }
        },
        onError: (error, variables, context) => {
            console.error(error);
            setErrorMessage(error.cause.code)
             setErrorMessage(getErrorMessage(t, error.cause?.code));
        }
    });

    const onVerify = async (e) => {
        e.preventDefault();
        const data = {code: values.code};
        await verifyMutation.mutateAsync(data);
    }

    return (
        <>
            <div className="common-page-body">
                <div className="two-step--verify">
                    <div className="two-step--verify__action">
                        <p>{t('@Get a verification code with your QNAP Authenticator@')}</p>

                        {
                            cur_url.searchParams.get('qauth_app')?.toLowerCase() === "true" &&
                            <p>
                                <button className="q-btn q-btn--default btn-rounded-full btn-tiny"
                                        onClick={onLaunchQnapAuth}>{t('@Launch QNAP Authenticator@')}</button>
                            </p>
                        }

                        <input type="text" name="code" value={values.code} maxLength="6" pattern="\d*"
                               onChange={onChange} className="input--must-fill"/>
                        {
                            errorMessage &&
                            <p className="text-error mt-10 !mb-0">{errorMessage}</p>
                        }

                        <div className="comp-add-ons">
                        <div className="countdown-timer">
                                <div className="countdown-timer__ic"></div>
                                <QnapAuthAppTimer class_name={"countdown-timer__time"} init_time={getTimerLeft()}
                                                  endAction={onCountDownToZero}/>
                            </div>
                        </div>

                    </div>
                </div>

                <p className="!mb-10"><a href='' onClick={otherWay}>{t('@Other ways to get a verification code@')}</a></p>
                <p className="!mb-0"><a href="#" onClick={e => {e.preventDefault(); setShowNotReceiveCode(true)}}>{t("@Did not receive a code?@")}</a></p>
            </div>
            <div className="common-page-footer">
                <div className="q-btn-group btn-align-right">
                    <button className="q-btn q-btn--primary btn-medium btn-rounded-normal" onClick={onVerify} disabled={values?.code?.length !== 6}>{t('@Verify@')}</button>
                    <button className="q-btn q-btn--default btn-medium btn-rounded-normal" onClick={signout}>{t('@Back@')}</button>
                </div>
            </div>

            {showNotReceiveCode && <NotReceiveCodeDialog showModal={showNotReceiveCode} closeModal={()=>setShowNotReceiveCode(false)}/>}
        </>
    );
}

export default QnapAuthByVerifyVerificationComponent;